import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "../../Styles/Header.css";
import BellIcon from "../../Assets/Icons/bellIcon.svg";
import ProfileAvatar from "../../Assets/Images/ProfileAvatar.png";
import MenuIcon from "../../Assets/Images/menu.png";
import { Button } from "react-bootstrap";

export default function Header({ isSidebarOpen, handleSidebar }) {
  return (
    <Container fluid>
      <Navbar className="navbar-con">
        <Button
          onClick={() => handleSidebar(!isSidebarOpen)}
          style={{ marginLeft: 40, backgroundColor: 'transparent', border: 'none' }}
        >
          <img
            style={{ width: "30px", height: "30px", cursor: "pointer" }}
            src={MenuIcon}
          />
        </Button>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav" style={{ width: "100%" }}>
            <div className="navbar-section">
              <div className="notification-con">
                <img src={BellIcon} alt="bellicon" />
                <div className="notification-indicator"></div>
              </div>
              <div className="profile-section">
                <img src={ProfileAvatar} alt="profileavatar" />
                <p>Admin</p>
              </div>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}
